<template>
	<div id="dashboard">
    <div v-if="dashboardReport">
      <div class="mb-base">
        <!-- <h3 class="mb-6">Dashboard</h3> -->
        <h1 class="text-3xl font-bold">{{dashboardReport.business_name}}</h1><p v-if="this.config.host_package != 'full'">You are using GCI LITE, to know about GCI Pro please contact us at: 832-968-6668.</p>
        <p class="my-1">ID: {{dashboardReport.id}}</p>
        <p>Member since {{formatSinceDay(dashboardReport.member_since)}} | <router-link to="/pages/app-setting"><a>View profile</a></router-link></p>
        <!-- <p>Timezone: US/Central | (1 reviews) | <router-link to="/review_list"><a>See all reviews</a></router-link></p> -->
      </div>
      <vx-card class="mb-base">
        <h4 class="p-0 mb-4 font-bold">Overview</h4>
        <div class="lg:flex">
          <div class="p-2 vx-col" :class="{'lg:w-1/2': dashboardReport.income && dashboardReport.income.isShow == 0,
                                            'lg:w-1/3': dashboardReport.income && dashboardReport.income.isShow == 1}"
              v-if="!config.hide_customer_statistic">
            <div class="overview-card p-6 h-full rounded-item">
              <p class="text-uppercase text-grey-custom text-lg">TOTAL MEMBERS</p>
              <div v-if="dashboardReport.customer">
                <h3 class="font-bold my-3">{{formatNumber(dashboardReport.customer.all)}}</h3>
                <p class="mb-2">
                  <span>Vip - </span>
                  <span class="text-grey-custom">{{formatNumber(dashboardReport.customer.vip)}} members</span>
                </p>
                <p class="mb-2">
                  <span>New - </span>
                  <span class="text-grey-custom">{{formatNumber(dashboardReport.customer.new)}} members</span>
                </p>
                <p class="mb-2">
                  <span>Regular - </span>
                  <span class="text-grey-custom">{{formatNumber(dashboardReport.customer.regular)}} members</span>
                </p>
                <p class="mb-2">
                  <span>At risk - </span>
                  <span class="text-grey-custom">{{formatNumber(dashboardReport.customer.atrisk)}} members</span>
                </p>
                <p class="mb-2">
                  <span>Normal - </span>
                  <span class="text-grey-custom">{{formatNumber(dashboardReport.customer.normal)}} members</span>
                </p>
              </div>
            </div>
          </div>
          <div class="p-2 vx-col" :class="{'lg:w-1/2': dashboardReport.income && dashboardReport.income.isShow == 0,
                                            'lg:w-1/3': dashboardReport.income && dashboardReport.income.isShow == 1}">
            <div class="overview-card p-6 h-full rounded-item">
              <p class="text-uppercase text-grey-custom text-lg">DELIVERED MESSAGES</p>
              <h3 class="font-bold my-3">{{formatNumber(dashboardReport.totalDelivery)}}</h3>
              <p>
                <span>Redemption - </span>
                <span class="text-grey-custom">{{formatNumber(dashboardReport.totalRedemption)}} times</span>
              </p>
            </div>
          </div>
          <div class="p-2 vx-col flex-grow" :class="{'px-0': dashboardReport.income && dashboardReport.income.isShow == 0,
                                            'lg:w-1/3': dashboardReport.income && dashboardReport.income.isShow == 1}">
            <div class="overview-card p-6 h-full rounded-item" v-if="dashboardReport.income && dashboardReport.income.isShow == 1">
              <p class="text-uppercase text-grey-custom text-lg">YOUR INCOME</p>
              <h3 class="font-bold my-3">${{formatNumber(dashboardReport.income.totalIncome)}}</h3>
              <!-- <div v-if="dashboardReport.lessRedemption">
                <p class="pb-4">
                  <span>Less Redemption - </span>
                  <span class="text-grey-custom">${{formatNumber(dashboardReport.lessRedemption)}}</span>
                </p>
                <vue-apex-charts type='radialBar' height='120' :options="chartOptions" :series="series"/>
              </div> -->
            </div>
          </div>
        </div>
      </vx-card>

      <vx-card class="mb-base">
        <h4 class="p-0 mb-4 font-bold">Review</h4>
        <div class="lg:flex">
          <div class="p-2 vx-col lg:w-1/3">
            <div class="overview-card p-6 h-full rounded-item">
              <p class="text-uppercase text-grey-custom text-lg">TOTAL REVIEWS</p>
              <div v-if="dashboardReport.review">
                <h3 class="font-bold my-3">{{formatNumber(dashboardReport.review.totalReview)}}</h3>
                <router-link :to="{name: 'review_list', params: {typeFromDashboard: 'gocheckin'}}">
                  <p class="mb-2 flex text-dark">
                    <img src="../assets/images/logo/newlogo.png" style="width: 20px; height: 20px" class="mr-2"/>
                    <span>Go Check-in - </span>
                    <span class="text-grey-custom d-inline-block ml-1">{{ formatNumber(dashboardReport.review.totalGoCheckinReview)}} reviews</span>
                  </p>
                </router-link>
                <!-- <router-link :to="{name: 'review_list', params: {typeFromDashboard: 'yelp'}}">
                  <p class="mb-2 flex text-dark">
                    <img src="../assets/images/logo/yelp.svg" style="width: 12px; height: 12px" class="mr-2"/>
                    <span>Yelp - </span>
                    <span class="text-grey-custom d-inline-block ml-1">{{ formatNumber(dashboardReport.review.totalYelpReview)}} reviews</span>
                  </p>
                </router-link> -->
                <router-link :to="{name: 'review_list', params: {typeFromDashboard: 'google'}}">
                  <p class="mb-2 flex text-dark">
                    <img src="../assets/images/logo/google-plus.svg" style="width: 20px; height: 20px" class="mr-2"/>
                    <span>Google - </span>
                    <span class="text-grey-custom d-inline-block ml-1">{{ formatNumber(dashboardReport.review.totalGoogleReview)}} reviews</span>
                  </p>
                </router-link>
              </div>
            </div>
          </div>
          <div class="p-2 vx-col lg:w-2/3">
            <div class="overview-card p-6 h-full rounded-item">
              <p class="text-uppercase text-grey-custom text-lg mb-3">LAST REVIEWS</p>
              <p class="mb-2 flex">
                <img src="../assets/images/logo/newlogo.png" style="width: 20px; height: 20px" class="mr-2"/>
                <span class="font-bold">Go Check-in</span>
              </p>

              <div class="mb-4" v-if="dashboardReport.review && dashboardReport.review.lastGoCheckinReview">
                <div v-if="dashboardReport.review.lastGoCheckinReview.rating" class="flex align-center">
                  <!-- <vs-icon icon="sentiment_very_satisfied" size="small" v-if="dashboardReport.review.lastGoCheckinReview.rating == 5"></vs-icon>
                  <vs-icon icon="sentiment_dissatisfied" size="small" v-if="dashboardReport.review.lastGoCheckinReview.rating == 3"></vs-icon>
                  <vs-icon icon="sentiment_very_dissatisfied" size="small" v-if="dashboardReport.review.lastGoCheckinReview.rating == 1"></vs-icon> -->
                  <div class="emotional-item" v-if="dashboardReport.review.lastGoCheckinReview.rating == 1">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-unhappy emotional-active">
                              <span></span>
                          </vs-button>
                      </div>
                  </div>
                  <div class="emotional-item" v-if="dashboardReport.review.lastGoCheckinReview.rating == 2">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn unhappy emotional-active">
                              <span></span>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item" v-if="dashboardReport.review.lastGoCheckinReview.rating == 3">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn normal emotional-active">
                              <span></span>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item" v-if="dashboardReport.review.lastGoCheckinReview.rating == 4">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn happy emotional-active">
                              <span></span>
                          </vs-button>
                      </div>
                  </div>

                  <div class="emotional-item" v-if="dashboardReport.review.lastGoCheckinReview.rating == 5">
                      <div class="emotional-icon">
                          <vs-button class="emotional-btn very-happy emotional-active">
                              <span></span>
                          </vs-button>
                      </div>
                  </div>
                  <span class="text-grey-custom block ml-2 text-sm">
                    - {{dashboardReport.review.lastGoCheckinReview.user_name}} ({{formatLastReviewDay(dashboardReport.review.lastGoCheckinReview.time_create)}})
                  </span>
                </div>
                <div v-if="dashboardReport.review.lastGoCheckinReview.content">
                  <div class="review-content">{{dashboardReport.review.lastGoCheckinReview.content}}</div>
                  <div class="text-grey-custom text-sm">
                    - {{dashboardReport.review.lastGoCheckinReview.user_name}} ({{formatLastReviewDay(dashboardReport.review.lastGoCheckinReview.time_create)}})
                  </div>
                </div>
              </div>

              <!-- <p class="mb-2 flex">
                <img src="../assets/images/logo/yelp.svg" style="width: 12px; height: 12px" class="mr-2"/>
                <span class="font-bold">Yelp</span>
              </p>

              <div class="mb-4" v-if="dashboardReport.review && dashboardReport.review.lastYelpReview">
                <star-rating :rating="dashboardReport.review.lastYelpReview.rating" :read-only="true" :increment="1" active-color="#EA5455" :star-size="15" :show-rating="false"></star-rating>
                <div>
                  <div class="review-content" v-if="dashboardReport.review.lastYelpReview.content">{{dashboardReport.review.lastYelpReview.content}}</div>
                  <div class="text-grey-custom text-sm">
                    - {{dashboardReport.review.lastYelpReview.user_name}} ({{formatLastReviewDay(dashboardReport.review.lastYelpReview.time_create)}})
                  </div>
                </div>
              </div> -->

              <p class="mb-2 flex">
                <img src="../assets/images/logo/google-plus.svg" style="width: 20px; height: 20px" class="mr-2"/>
                <span class="font-bold">Google</span>
              </p>

              <div class="mb-4" v-if="dashboardReport.review && dashboardReport.review.lastGoogleReview">
                <star-rating :rating="dashboardReport.review.lastGoogleReview.rating" :read-only="true" :increment="1" :star-size="15" :show-rating="false"></star-rating>
                <div>
                  <div class="review-content" v-if="dashboardReport.review.lastGoogleReview.content">{{dashboardReport.review.lastGoogleReview.content}}</div>
                  <div class="text-grey-custom text-sm">
                    - {{dashboardReport.review.lastGoogleReview.user_name}} ({{formatLastReviewDay(dashboardReport.review.lastGoogleReview.time_create)}})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <vx-card class="mb-base" v-if="!config.hide_customer_statistic">
      <h4 class="font-bold">Customer Chart</h4>
      <div class="flex justify-between align-center mb-6 responsive-customer-chart-btn">
        <div v-if="type=='day'">
         <div class="flex items-center justify-start mb-6 mt-6">
            <datepicker :disabledDates="disabledFromDates" v-model="from_date" v-on:selected="changeFromDay()"></datepicker>
            <div class="mx-3">to</div>
            <datepicker disabled v-model="to_date"></datepicker>
          </div>
        </div>
        <div v-if="type=='week'">
          <div class="flex items-center justify-start mb-6 mt-6">
            <datepicker :minimumView="'month'" :maximumView="'month'" v-model="from_week" v-on:selected="changeFromWeek()"></datepicker>
            <!-- <datepicker :disabledDates="disabledFromWeeks" v-model="from_week" v-on:selected="changeFromWeek()"></datepicker> -->
            <!-- <div class="mx-3">to</div>
            <datepicker disabled v-model="to_week"></datepicker> -->
          </div>
        </div>
        <div v-if="type=='month'">
          <div class="flex items-center justify-start mb-6 mt-6">
            <datepicker :minimumView="'year'" :maximumView="'year'" format="yyyy" :disabledDates="disabledFromYear" v-model="from_year" v-on:selected="changeFromYear()"></datepicker>
          </div>
        </div>
        <div class="chart-button flex flex-wrap-reverse items-center flex-grow justify-end mb-6 mt-6">
          <vs-button type="border" class="mr-2 customer-chart-filter-btn" @click="changeDayChart" :class="{'active': type == 'day'}">Day</vs-button>
          <vs-button type="border" class="mr-2 customer-chart-filter-btn" @click="changeWeekChart" :class="{'active': type == 'week'}">Week</vs-button>
          <vs-button type="border" class="mr-2 customer-chart-filter-btn" @click="changeMonthChart" :class="{'active': type == 'month'}">Month</vs-button>
          <vs-button type="border" class="customer-chart-filter-btn" @click="changeYearChart" :class="{'active': type == 'year'}">Year</vs-button>
        </div>
      </div>
      <div class="position-relative">
        <div v-if="type == 'month'" class="font-bold text-xl color-black" style="position: absolute; top: 2px; right: 2px;">
          {{new Date(from_year).getFullYear()}}
        </div>
        <line-chart :chartInfo="chartInfo" :typeChart="type" class="w-full mt-12" :key="chart_key"></line-chart>
      </div>
    </vx-card>
	</div>
</template>

<script>
import StarRating from "vue-star-rating";
import VueApexCharts from 'vue-apexcharts'
import Datepicker from 'vuejs-datepicker';
import { StringHelper } from '../models/string_helper';
import {changeFormatHelper} from '../helper/datetimeHelper';
import moment from 'moment';
// import moment from 'moment';
export default {
  components: {
    VueApexCharts,
    StarRating,
    Datepicker,
  },
  data(){
    return{
      chartOptions: this.$store.getters['dashboard/chartOptions'],
      series: [],
      disabledFromDates: {

      },
      disabledFromWeeks: {

      },
      disabledFromYear: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)
      },
      StringHelper,
      type: 'day',
      from_date: '',
      to_date: '',
      from_week: '',
      from_year: new Date(new Date().getFullYear(), 0, 1),
      // to_week: '',
      chartInfo : {
      },
      data: [],
      chart_key: 0,
      loaded_data_num: 0,
      isOpenLoading: false
    }
  },
  watch:{
    chartReport:{
      immediate: true,
      deep: true,
      handler(){
        this.getData(this.chartReport);
      }
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 4) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' staff failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    getData(data) {
      let obj = {
        labels: [],
        datasets: [
          {
            label: 'Checked In',
            backgroundColor: 'rgb(30, 79, 160)',
            data: []
          },
          {
            label: 'New Client',
            backgroundColor: 'rgb(122, 170, 250)',
            data: []
          },
        ]
      };
      if(data) {
        for(let i = 0; i < data.length; i++) {
          obj.labels.push(data[i].category);
          obj.datasets[0].data.push(parseInt(data[i].checkin));
          obj.datasets[1].data.push(parseInt(data[i].new_sign_up));
        }
      }
      this.chart_key++;
      return obj;
    },
    changeFromDay(){
      var dateOffset = (24*60*60*1000) * 11;
      this.from_date = new Date(this.from_date);
      this.$nextTick(() => {
        this.to_date = new Date((this.from_date.getTime() + dateOffset));
        const obj = {
          start: moment(this.from_date).format('YYYY-MM-DD'),
          type: this.type
        }
        this.openLoadingInDiv();
        this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
          this.closeLoading();
          this.data = response;
          this.chartInfo = this.getData(this.data);
        })
      })
    },
    changeFromWeek(){
      // var dateOffset = (24*60*60*1000) * 84;
      this.from_week = new Date(this.from_week);
      this.$nextTick(() => {
        // this.to_week = new Date((this.from_week.getTime() + dateOffset));
        const obj = {
          start: moment(this.from_week).format('YYYY-MM-DD'),
          type: this.type
        }
        this.openLoadingInDiv();
        this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
          this.closeLoading();
          this.data = response;
          this.chartInfo = this.getData(this.data);
        })
      })
    },
    changeFromYear() {
      this.from_year = new Date(this.from_year);
      this.$nextTick(() => {
        const obj = {
          start: moment(this.from_year).format('YYYY'),
          type: this.type
        }
        this.openLoadingInDiv();
        this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
          this.closeLoading();
          this.data = response;
          this.chartInfo = this.getData(this.data);
        })
      })
    },
    changeDayChart(){
      this.to_date = new Date();
      this.type = 'day'
      var dateOffset = (24*60*60*1000) * 11;
      this.from_date = (this.to_date.getTime() - dateOffset);
      let disabledFromDate = new Date(this.from_date)
      this.disabledFromDates.from = new Date(disabledFromDate.getFullYear(), disabledFromDate.getMonth(), disabledFromDate.getDate() + 1);
      const obj = {
        start: moment(this.from_date).format('YYYY-MM-DD'),
        type: this.type
      }
      this.openLoadingInDiv();
      this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
        this.closeLoading();
        this.data = response;
        this.chartInfo = this.getData(this.data);
      })
    },
    changeWeekChart(){
      this.type = 'week'
      // this.to_week = new Date();
      // var dateOffset = (24*60*60*1000) * 84;
      this.from_week = new Date()
      // let disabledFromWeek = new Date(this.from_week);
      // this.disabledFromWeeks.from = new Date(disabledFromWeek.getFullYear(), disabledFromWeek.getMonth(), disabledFromWeek.getDate() + 1);
      const obj = {
        start: moment(this.from_week).format('YYYY-MM-DD'),
        type: this.type
      }
      this.openLoadingInDiv();
      this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
        this.closeLoading();
        this.data = response;
        this.chartInfo = this.getData(this.data);
      })
    },
    changeMonthChart(){
      this.type = 'month'
      const obj = {
        start : new Date().getFullYear(),
        type: this.type
      }
      this.openLoadingInDiv();
      this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT" , obj).then((response) => {
        this.closeLoading();
        this.data = response;
        this.chartInfo = this.getData(this.data);
      })
    },
    changeYearChart(){
      this.type = 'year'
      const obj = {
        start : new Date().getFullYear(),
        type: this.type
      }
      this.openLoadingInDiv();
      this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT" , obj).then((response) => {
        this.closeLoading();
        this.data = response;
        this.chartInfo = this.getData(this.data);
      })
    },
    formatNumber(num) {
      if(num) {
        return parseFloat(num).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
      return 0;
    },
    // getTotalReview() {
    //   let total = 0;
    //   if(this.reviewReport) {
    //     if(this.reviewReport.total_gocheckin_review) {
    //       total += parseInt(this.reviewReport.total_gocheckin_review);
    //     }
    //     if(this.reviewReport.total_yelp_review) {
    //       total += parseInt(this.reviewReport.total_yelp_review);
    //     }
    //     if(this.reviewReport.total_google_review) {
    //       total += parseInt(this.reviewReport.total_google_review);
    //     }
    //   }
    //   return this.formatNumber(total);
    // },
    formatSinceDay(date) {
      if(date) {
        return moment(date).format('MMM YYYY');
      } else {
        return 'N/A';
      }
    },
    formatLastReviewDay(date) {
      if(date) {
        return changeFormatHelper(date);
      } else {
        return 'N/A';
      }
    },
    getSeries(data) {
      this.series = [];
      if(data) {
        let percent = +(Math.round(((data.lessRedemption / data.totalIncome)*100) + "e+2") + "e-2");
        this.series.push(percent);
      } else {
        this.series.push(0);
      }
    }
  },
  computed:{
    chartReport(){
      return this.$store.getters["dashboard/chartReport"];
    },
    dashboardReport() {
      return this.$store.getters['dashboard/dashboardReport'];
    },
    config(){
      return this.$store.getters["auth/config"];
    }
  },
  created(){
    this.$store.dispatch("customerList/GET_CHART_INFO").then(() => {
      this.loaded_data_num++;
    });
    this.$store.dispatch('reviewList/GET_REVIEW_REPORT').then(() => {
      this.loaded_data_num++;
    });

    this.to_date = new Date();
    var dateOffset = (24*60*60*1000) * 11;
    this.from_date = (this.to_date.getTime() - dateOffset);
    let disabledFromDate = new Date(this.from_date)
    this.disabledFromDates.from = new Date(disabledFromDate.getFullYear(), disabledFromDate.getMonth(), disabledFromDate.getDate() + 1);
    const obj = {
      start: moment(this.from_date).format('YYYY-MM-DD'),
      type: this.type
    }

    this.$store.dispatch("dashboard/GET_DASHBOARD_CHART_REPORT", obj).then((response) => {
      this.data = response;
      this.chartInfo = this.getData(this.data);
      console.log(this.chartInfo);
      this.loaded_data_num++;
    })

    this.$store.dispatch('dashboard/GET_DASHBOARD_REPORT').then((response) => {
      this.getSeries(response);
      this.loaded_data_num++;
    });
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
#dashboard {
  .overview-card {
    box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.1);
  }
  .apexcharts-canvas {
    // transform: translateX(-25%) !important;
    * {
      transform: unset !important;
    }
    transform: translateX(-10px);
  }
  .vdp-datepicker input {
    width: 120px;
    text-align: center;
    // margin-right: 15px;
    cursor: pointer;
  }

  .chart-button {
    .vs-button--text{
      color: $primary !important;
    }
    .active {
      background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7)) !important;
      border: none;
      .vs-button--text{
        color: #fff !important;
      }
    }

    .vs-button--background {
      opacity: 0 !important;
      display: none !important;
      // color: $primary;
    }
  }

  .review-content {
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 800px) {
    .responsive-customer-chart-btn {
      display: block !important;
    }

    .customer-chart-filter-btn {
      margin: 0 0 10px;
    }
  }

  .emotional-item {
        position: relative;
        width: 30px;
        height: 30px;
        // margin: 0 15px;
    }

    .emotional-icon {
      transform: scale(0.1);
      position: absolute;
      /* top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); */
      top: 0;
      left: 0;
      width: 0;
      height: 0;
  }

  .button {
      border: none !important;
      box-shadow: none !important;
  }

  .emotional-btn {
      background: url('../assets/images/rating-icon.png') no-repeat;
      display: inline-block;
      position: relative;
      /* text-indent: -9999px; */
      width: 250px;
      height: 250px;
      border-radius: 50%;
      background-position-y: -480px;
      cursor: pointer;
  }

  .emotional-btn span {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('../assets/images/rating-icon.png') no-repeat;
      background-position-y: -151px;
      opacity: 0;
      transition: opacity 0.2s ease;
      -webkit-transition: opacity 0.2s ease;
      -moz-transition:    opacity 0.2s ease;
      -o-transition:      opacity 0.2s ease;
  }

  .emotional-btn:hover span, .emotional-btn.emotional-active span {
      opacity: 1;
  }

  .very-unhappy, .very-unhappy span {
      background-position-x: -1174px;
  }

  .unhappy, .unhappy span {
      background-position-x: -904px;
  }

  .normal, .normal span {
      background-position-x: -634px;
  }

  .happy, .happy span {
      background-position-x: -364px;
  }

  .very-happy, .very-happy span {
      background-position-x: -94px;
  }

  .emotional-btn .content {
    position: absolute;
    left: calc(100% + 100px);
    top: 50%;
    height: inherit;
    width: max-content;
    transform: translateY(-50%);
    font-size: 150px;
    line-height: 2;
  }
}
</style>
